import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getOrdersExport = api.injectEndpoints({
  endpoints: builder => ({
    getOrdersExport: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `export/orders`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{message: string}>;

export const {useLazyGetOrdersExportQuery} = getOrdersExport;
